import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { ViewAsClientService } from 'app/core/services/view-as-client.service';
import { ClientsService } from '../../../core/services/clients.service';
import { Client } from 'app/core/models/client.model';
import { ClientStatus } from '../../../core/enums/client-status.enum';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';

import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-client-actions',
    templateUrl: './client-actions.component.html',
    styleUrls: ['./client-actions.component.scss'],
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, RouterLink, FaIconComponent]
})
export class ClientActionsComponent implements OnInit {
  private clientsService = inject(ClientsService);
  private viewAsClientService = inject(ViewAsClientService);
  private authService = inject(AuthenticationService);

  clientStatuses = ClientStatus;
  processing = false;
  canManageClientConfigurations = false;

  @Input() client: Client;
  @Output() public clientChange = new EventEmitter<Client>();

  ngOnInit() {
    this.canManageClientConfigurations = this.authService.hasPermissionTo(UserRoleName.manageClientConfigurations);
  }

  onViewPortalClick($event) {
    this.viewAsClientService.viewAsClient($event, this.client);
  }

  onDeactivateClick($event) {
    $event.preventDefault();
    if (confirm(`Are you sure you want to deactivate ${this.client.humanizedName} client?`)) {
      this.processing = true;
      this.clientsService.deactivate(this.client.id).subscribe(client => {
        this.processing = false;
        this.client = client;
        this.clientChange.emit(client);
      });
    }
  }

  onReactivateClick($event) {
    $event.preventDefault();
    if (confirm(`Are you sure you want to activate ${this.client.humanizedName} client?`)) {
      this.processing = true;
      this.clientsService.activate(this.client.id).subscribe(client => {
        this.processing = false;
        this.client = client;
        this.clientChange.emit(client);
      });
    }
  }
}
